import type {InterfaceStrings} from './strings'

export const ja: InterfaceStrings = {
    nav: {
        beginSession: 'はじめる',
        faq: 'よくある質問',
        pricing: '料金',
        legal: '法的情報',
        signIn: 'ログイン',
        viewPricing: '料金を見る',
        signOut: 'ログアウト',
        account: 'アカウント',
        menu: 'メニュー',
        closeMenu: 'メニューを閉じる',
        mainNav: 'メインナビゲーション',
        sessions: {other: '{n}回分'},
    },
    footer: {
        selfHypnosisFor: '自己催眠',
        anxiety: '不安に',
        sleep: '眠りに',
        stress: 'ストレスに',
        confidence: '自信のために',
        focus: '集中のために',
        learn: '方法を知る',
        ericksonian: 'エリクソン催眠とは',
        aiHow: 'AI催眠のしくみ',
        vsMeditation: '催眠と瞑想',
        methods: '技法',
        languages: '言語',
    },
    page: {
        cta: '無料セッションを始める',
        hint: '最初のセッションは無料です',
        exploreFurther: 'さらに読む',
        disclaimer:
            'Quiesはリラクゼーションと自己探求のためのウェルネスツールです。医療機器ではなく、いかなる疾患の診断・治療・治癒も行いません。心の危機にあるときは、専門家にご相談ください。',
        transcript: '書き起こし',
        transcriptNote: '実際のQuiesセッションの一部を、読み上げられたとおりに。',
        breadcrumb: 'パンくずリスト',
    },
    pricing: {
        selectPlan: 'このプランを選ぶ',
        subscribe: '定期購入する',
        perMonth: '/ 月',
        manageSubscription: '定期購入を管理する',
        replayFree: '過去のセッションを聴き直すのは、いつでも無料です。',
        offerLead: '毎回のセッションは、前回の続きから始まります。',
    },
    session: {
        chooseLanguage: '言語を選んでください',
        changeLanguage: '言語を変更',
        changeVoice: '声を変更',
        previewVoice: '{voice}の声を試聴',
        stopPreview: '試聴を止める',
        continue: '続ける',
        composing: 'Quiesがセッションを書いています',
        preparing: '瞑想を準備しています',
        pickingUp: '前回の続きから',
        today: '今日',
        yesterday: '昨日',
        loading: '読み込み中…',
        showEarlier: 'それ以前を表示（{count}）',
        tryDifferentApproach: '別の道を試す',
        nothingAdded: '追記なし',
        purchaseConfirmed: 'ご購入を確認しました',
        firstSessionNote: '最初のセッションは無料です。お聴きになる前にログインしていただきます。',
    },
    threshold: {
        title: 'ログインして聴く',
        message: '最初のセッションは無料です。カードは不要です。',
        google: 'Googleで続ける',
        sendLink: 'ログイン用リンクを送る',
        sending: '送信中…',
        emailLabel: 'メールアドレス',
        or: 'または',
        waitingTitle: 'メールをご確認ください',
        waitingBody: '{email} にログイン用リンクを送りました。',
        sendAgain: 'もう一度送る',
        googleInstead: '代わりにGoogleでログイン',
        codeLabel: 'またはメールに届いた6桁のコードを入力',
        codeSubmit: '続ける',
        codeSubmitting: '確認中…',
        codeWrong: 'このコードは正しくありません。',
        codeDead: 'このコードはもう使えません。メールのリンクを使うか、新しいメールを送信してください。',
        errors: {
            invalidEmail: '有効なメールアドレスを入力してください。',
            rateLimited: '試行回数が多すぎます。数分後にもう一度お試しください。',
            sessionError: 'ログインに問題が起きました。ページを更新して、もう一度お試しください。',
            sendFailed: 'メールを送信できませんでした。もう一度お試しください。',
            sessionExpired: 'ログインの有効期限が切れました。ページを更新して、もう一度お試しください。',
            generic: '問題が起きました。もう一度お試しください。',
        },
    },
    player: {
        play: '再生',
        pause: '一時停止',
        playAgain: 'もう一度聴く',
        seek: '再生位置',
        eyesClosed: '目を閉じて',
        openEyes: '目を開ける',
        paused: '一時停止中',
        unavailable: '音声を再生できません',
        untitled: 'Quiesセッション',
    },
    failure: {
        turnFailed: 'こちらで問題が起きました。あなたの回答は保存されています。',
        reconnecting: '再接続しています…',
        refusalTitle: '別の道を行きましょう',
        refusal: 'メッセージの一部にお答えできませんでした。言い方を変えるか、もう一度送ってください。',
        openElsewhere: 'このセッションは別のウィンドウでも開かれています。',
        serviceDown: 'ただいまQuiesにつながりません。これまでの内容は失われていません。',
        sessionsUsedTitle: 'セッションをすべてご利用になりました',
        voiceFailedTitle: '瞑想は書き上がっています',
        voiceFailed: 'いまは音声にできませんでした。何も失われていません。もう一度読み上げても料金はかかりません。',
        voiceStopped: '声が途中で止まりました。止まったところから続けられます。',
        streamMissing: '瞑想は準備できていますが、このページに届いていません。',
        tapToListen: 'タップして聴く',
        fileFailed: 'この録音は再生できません。瞑想は無料でもう一度読み上げられます。',
        recordingGone: 'この録音はもう保存されていません。',
        purchaseCancelled: '購入はキャンセルされました。料金は請求されていません。',
        purchasePending: 'お支払いは確認済みです。セッションの反映にいつもより時間がかかっています。',
        checkoutFailed: 'お支払いを完了できませんでした。料金は請求されていません。',
        sessionEnded: 'このセッションは終わりを迎えました。',
        busy: 'ただいまQuiesが混み合っています。回答は保存されています。1分ほどしてからもう一度お試しください。',
        tooLong: 'このセッションはQuiesが扱える長さを超えました。セッション1回分をお返ししました。',
        notSaved: 'このステップを保存できませんでした。ここから続けるには、もう一度お試しください。',
        meditationRefused:
            'この瞑想はご希望どおりに書けませんでした。言い方を変えるか、はじめからやり直してください。このセッション1回分はお返しします。',
        meditationRefusedUncharged: 'この瞑想はご希望どおりに書けませんでした。言い方を変えるか、はじめからやり直してください。',
        linkExpired: 'ログイン用リンクの有効期限が切れました。新しいリンクをリクエストしてください。',
        oauthFailed: 'ログインが中断されました。もう一度お試しください。',
        offline: 'オフラインです。接続が戻りしだい、回答を送信します。',
        voiceChanged: '選んだ声は利用できなくなりました。この瞑想は別の声で読み上げます。',
        voiceReturned: 'やはり音声にできませんでした。セッション1回分をお返ししました。',
        voiceFailedAgain: 'やはり音声にできませんでした。',
        voiceResuming: '声が戻ってきています…',
        voiceLimited: 'この1時間に、すでにいくつもの瞑想を読み上げました。少し時間をおいてからお試しください。',
        tryAgain: 'もう一度試す',
        rephrase: '言い方を変える',
        resume: '再開する',
        voiceAgain: 'もう一度読み上げる',
        listen: '聴く',
        continue: '続ける',
        begin: 'セッションをはじめる',
        signIn: 'ログイン',
        checkAgain: 'もう一度確認する',
        sendLink: 'ログイン用リンクを送る',
        useEmail: 'メールアドレスで続ける',
    },
}
